import { render, staticRenderFns } from "./PdfIndexsearch.vue?vue&type=template&id=3808dd04&scoped=true"
import script from "./PdfIndexsearch.vue?vue&type=script&lang=js"
export * from "./PdfIndexsearch.vue?vue&type=script&lang=js"
import style0 from "./PdfIndexsearch.vue?vue&type=style&index=0&id=3808dd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3808dd04",
  null
  
)

export default component.exports